import type { InviteUsersFailedRowDto } from '@/types/generated/schemas';

const reasonText: Record<InviteUsersFailedRowDto['reasonCode'], string> = {
  VALIDATION_FAILED: 'Check the invitation details and try again.',
  CERTIFICATE_MISSING: 'Add a peer support certificate and try again.',
  CERTIFICATE_INVALID: 'Check the peer support certificate details.',
  CERTIFICATE_IN_USE: 'This certificate is already assigned to another member.',
  ALREADY_MEMBER: 'This person is already a member of the organization.',
  ALREADY_REGISTERED: 'This email is already registered. Check the existing account.',
  ACCOUNT_LOOKUP_AMBIGUOUS: 'Multiple accounts match this person. Contact support.',
  CLEANUP_FAILED: 'The invitation could not be completed. Contact support before trying again.',
  ROLE_CONFIGURATION: 'The requested role could not be assigned. Check the role settings.',
  USER_NOT_ELIGIBLE: 'This person is not eligible for an invitation. Check their details.',
  INVITE_FAILED: 'The invitation could not be sent. Try again later.',
};

export const getInviteFailureReason = (row: InviteUsersFailedRowDto): string =>
  row.reasonCode === 'INVITE_FAILED' && row.message && row.message !== row.reasonCode
    ? row.message
    : (reasonText[row.reasonCode] ?? 'The invitation could not be completed. Contact support.');

export const getInviteFailures = (error: unknown): InviteUsersFailedRowDto[] => {
  if (typeof error !== 'object' || error === null || !('failed' in error)) return [];
  const failed = error.failed;
  return Array.isArray(failed) ? (failed as InviteUsersFailedRowDto[]) : [];
};
